"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _config = require("../../../config/config");

var _colors = require("../../../config/colors");

var QuestionTypes = function QuestionTypes(_ref) {
  var questionType = _ref.questionType,
      handleChange = _ref.handleChange,
      textTypes = _ref.textTypes,
      numericTypes = _ref.numericTypes,
      checkboxTypes = _ref.checkboxTypes,
      signatureTypes = _ref.signatureTypes;
  var _window$pdfFormConfig = window.pdfFormConfigObject,
      fieldLabels = _window$pdfFormConfig.field_labels,
      invertedFieldTypes = _window$pdfFormConfig.inverted_field_types;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        marginTop: '0px'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontSize: 14,
        fontWeight: 300
      }
    }, "Type"),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "select-wrapper"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control, {
      as: "select",
      name: "question_type",
      onChange: handleChange,
      "data-cy": "details-type-select",
      value: questionType,
      style: {
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontSize: 14,
        fontWeight: 300
      }
    }, textTypes.includes(questionType) && textTypes.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("option", {
          value: value,
          key: value
        }, fieldLabels[invertedFieldTypes[value]])
      );
    }), numericTypes.includes(questionType) && numericTypes.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("option", {
          value: value,
          key: value
        }, fieldLabels[invertedFieldTypes[value]])
      );
    }), checkboxTypes.includes(questionType) && checkboxTypes.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("option", {
          value: value,
          key: value
        }, fieldLabels[invertedFieldTypes[value]])
      );
    }), signatureTypes.includes(questionType) && signatureTypes.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("option", {
          value: value,
          key: value
        }, fieldLabels[invertedFieldTypes[value]])
      );
    }))))
  );
};

QuestionTypes.defaultProps = {
  questionType: 0
};
QuestionTypes.propTypes = process.env.NODE_ENV !== "production" ? {
  questionType: _propTypes["default"].number,
  handleChange: _propTypes["default"].func.isRequired,
  textTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  numericTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  checkboxTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  signatureTypes: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired
} : {};

var _default = exports["default"] = QuestionTypes;